"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "micigliano": {
    "2b608da5": [{
      "hkey": "25e8fca4",
      "slug": "micigliano",
      "name": "Micigliano",
      "primary": true,
      "skipSearch": false
    }],
    "san-quirico": [{
      "hkey": "25e8fca4",
      "slug": "micigliano",
      "name": "Micigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bebea1b0": [{
      "hkey": "25e8fca4",
      "slug": "micigliano",
      "name": "Micigliano",
      "primary": true,
      "skipSearch": false
    }],
    "terminillo": [{
      "hkey": "25e8fca4",
      "slug": "micigliano",
      "name": "Micigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;